import { TableContainer as MuiTableContainer } from '@mui/material';
import { shouldNotForwardProps } from '../../helpers';
import { styled } from '../muiReexports';
export const StickyTableContainer = styled(MuiTableContainer, shouldNotForwardProps('stickyHeader'))(({ stickyHeader }) => ({
    ...(stickyHeader && {
        /** Required for table `sticky` style to work. */
        overflowX: 'unset',
    }),
}));
